import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../Button/Button';
import Icon from '../../Icons/Icon';
import Modal from '../Modal';
import styles from './ConfirmationModal.module.css';
import { ConfirmationModalProps } from './ConfirmationModal.types';

/**
 *
 * @param props {ConfirmationModalProps} Required - confirmation modal properties
 * @param props.title {ReactNode} Required - title to display at top of modal
 * @param props.isOpen {boolean} Required - controls if modal is open/closed
 * @param props.onClose {() => void} Required - called when the close button is clicked; should close the modal
 * @param props.buttonText {ReactNode} Optional - text displayed on modal button
 * @returns JSX (Portal)
 */
const ConfirmationModal: FC<ConfirmationModalProps> = ({
  title,
  isOpen,
  hideStatusUpdateText,
  onClose,
  buttonText,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      headerContent={<div className={styles.header}>{title}</div>}
      footerContent={
        <div className={styles.footer}>
          <div className={styles.footerMessage}>
            <p>
              {!hideStatusUpdateText && (
                <Trans
                  i18nKey="confirmationModal.viewEmailForUpdates"
                  components={[<Link key="submission" to="/submissions" onClick={onClose} />]}
                />
              )}
            </p>
          </div>
          <br />
          <Button onClick={onClose}>{buttonText ?? t('confirmationModal.buttonText')}</Button>
        </div>
      }
      onClose={onClose}
      isOpen={isOpen}
      bodyContent={<div className={styles.body}>{children || <Icon iconName="CheckCircle" size="46" />}</div>}
    />
  );
};

export default ConfirmationModal;
